"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorageNumber = exports.toRoundedPercentage = exports.formatCompactViewDuration = exports.formatViewDuration = exports.formatDatetime = void 0;
var round_1 = __importDefault(require("lodash/round"));
var luxon_1 = require("luxon");
var react_1 = require("react");
function formatDatetime(date, timeZone, showTimeZone) {
    if (showTimeZone === void 0) { showTimeZone = false; }
    return new Intl.DateTimeFormat(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h12",
        timeZone: timeZone,
        timeZoneName: showTimeZone ? "short" : undefined,
    }).format(date);
}
exports.formatDatetime = formatDatetime;
function formatViewDuration(milliseconds) {
    var nearestSecond = (0, round_1.default)(milliseconds, -3);
    var duration = luxon_1.Duration.fromMillis(nearestSecond).shiftTo("minutes", "seconds");
    return "".concat(duration.minutes, "m ").concat(duration.seconds, "s");
}
exports.formatViewDuration = formatViewDuration;
function formatCompactViewDuration(milliseconds) {
    var nearestSecond = (0, round_1.default)(milliseconds, -3);
    return luxon_1.Duration.fromMillis(nearestSecond).shiftTo("hours", "minutes", "seconds").toFormat("hh:mm:ss");
}
exports.formatCompactViewDuration = formatCompactViewDuration;
function toRoundedPercentage(n) {
    return "".concat((0, round_1.default)(n * 100, 1), "%");
}
exports.toRoundedPercentage = toRoundedPercentage;
function useLocalStorageNumber(key, defaultValue, options) {
    var isDisabled = (options === null || options === void 0 ? void 0 : options.disabled) === true;
    var _a = __read((0, react_1.useState)(function () {
        if (isDisabled)
            return defaultValue;
        var storedValue = localStorage.getItem(key);
        if (storedValue) {
            var storedIndex = parseInt(storedValue);
            if (!isNaN(storedIndex)) {
                return storedIndex;
            }
        }
        return defaultValue;
    }), 2), state = _a[0], setStateFunction = _a[1];
    (0, react_1.useEffect)(function () {
        if (isDisabled)
            return;
        localStorage.setItem(key, state.toString());
    }, [key, state, isDisabled]);
    return [state, setStateFunction];
}
exports.useLocalStorageNumber = useLocalStorageNumber;
